import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";

// Constructor
export class ScreenTransitionController {

  constructor() {
    gsap.registerPlugin(Draggable, InertiaPlugin);
    this.$currentScreen = null;
    this.fromId = null;

    this.screenTransitionTimeline = null;
    this.idleTimeline = null;
  }

  playIdle(onComplete) {
    if (this.idleTimeline) this.idleTimeline.kill();

    const $allIdleItems = this.$currentScreen.find(".idle-container, .idle-overlay, .idle-element");
    if ($allIdleItems.length === 0) {
      onComplete?.();
      return;
    }

    const uniqueParents = [];
    $allIdleItems.each((i, el) => {
      const parent = el.parentElement;
      if (!uniqueParents.includes(parent)) {
        uniqueParents.push(parent);
      }
    });

    this.idleTimeline = gsap.timeline({
      onComplete: () => {
        onComplete?.();
        this.idleTimeline = null;
      }
    });

    uniqueParents.forEach((parent, i) => {
      const $parent = $(parent);
      const $elementToHide = $parent.find(".idle-container");
      const $elementToShow = $parent.find(".idle-overlay, .idle-element");
      const startTime = i * 0.03;

      // Hide the container
      if ($elementToHide.length) {
        this.idleTimeline.to($elementToHide, {
          autoAlpha: 0.0, y: -8, duration: 0.35, ease: "power2.inOut"
        }, startTime);
      }

      // Show the shimmer/elements
      if ($elementToShow.length) {
        gsap.set($elementToShow, {
          y: 12,
          autoAlpha: 0
        });
        this.idleTimeline.to($elementToShow, {
          autoAlpha: 1.0, y: 0, duration: 0.50, ease: "power2.out",
        }, startTime + 0.04);
      }
    });
  }

  /**
   * @param {number} fromId
   * @param {number} toId
   * @param {Function} goToScreenCallback
   * @param {Function} goToScreenFn
   * @param {{ maxAnimatedScreen?: number, onComplete?: Function }} options
   */
  transition(fromId, toId, goToScreenCallback, goToScreenFn, options = {}) {
    // Destructure options for consistent and clean access
    const {
      maxAnimatedScreen = null,
      onComplete,
      logicalToId,
      logicalFromId,
      allowSameScreenTransition = false
    } = options;
    this.fromId = fromId;

    // Prevent self-transition
    if (fromId === toId && !allowSameScreenTransition) {
      goToScreenFn?.(() => {
        goToScreenCallback?.();
        onComplete?.();
      });
      return false
    }

    // Prevent click while the screen is animating
    $("body").css("pointer-events", "none");

    // Allow to override
    const animFromId = logicalFromId ?? fromId;
    const animToId = logicalToId ?? toId;

    // Direction based on actual screen order
    const direction = animToId > animFromId ? 'Right' : 'Left';

    // Resolve animation handlers with directional fallback
    const outFn = this[`screen${animFromId}Out${direction}Animation`]
      ?? this[`screen${animFromId}OutAnimation`];
    const inFn = this[`screen${animToId}In${direction}Animation`]
      ?? this[`screen${animToId}InAnimation`];

    // Kill any running transition immediately
    this.screenTransitionTimeline?.progress(1, false).kill();
    this.screenTransitionTimeline = null;

    // No animations — just switch screen
    if (!outFn && !inFn) {
      return goToScreenFn?.(() => {
        goToScreenCallback?.();
        onComplete?.();
      });
    }

    // IN - Handle cleanup and start the animation
    const startInAnimation = () => {
      goToScreenCallback?.();
      this.$currentScreen = $(`#screen-${toId}`);

      // If IN animation, trigger it
      if (inFn) {
        this.screenTransitionTimeline = gsap.timeline({onComplete});
        inFn.call(this);
      } else {
        // If no IN animation, trigger completion immediately
        onComplete?.();
      }
    };

    // OUT - Start fresh timeline
    this.screenTransitionTimeline = gsap.timeline();
    this.$currentScreen = $(`#screen-${fromId}`);
    // OUT - Play animation if it exists
    if (outFn) outFn.call(this);

    // SWITCH - Once OUT animation end, swap screens and trigger IN animation
    this.screenTransitionTimeline.add(() => {
      this.$currentScreen = $(`#screen-${toId}`);
      goToScreenFn?.(startInAnimation);
    });

    return this.screenTransitionTimeline;
  }

  reset() {
  }
}
